module.exports = __webpack_public_path__ + "img/entradasSalidas.5fa41c1f.png";